/*******************************************************************************
* ReturnReceipt *
/**
* @ngdoc   run
* @module  csm.books.com.returnItems
* @name    csm.books.com.returnItems.run:ReturnReceipt
* @description
* Creates a data object constructor by setting default values and functions on
* the prototype. The data will be initialized from the `receipt` and `entryDate`.
*******************************************************************************/
/* @ngInject */ export function ReturnItemRunReturnReceipt(
  Data,
  LocalDateSerializer,
  SERVER
) {
  /*****************************************************************************
   * Constructor
   *****************************************************************************/
  Data.ReturnReceipt = function (receipt, entryDate) {
    var returnReceipt = {
      entryDate: entryDate,
      memo: 'Return of item(s) from Receipt #{0}'.format(receipt.number),
      entityID: receipt.entityID
    };

    return Object.assign(
      Object.create(Data.ReturnReceipt.prototype),
      returnReceipt
    );
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  Data.ReturnReceipt.prototype = {
    type: SERVER.BooksDBConstants.LET_RETURN_RECEIPT,
    source: SERVER.BooksDBConstants.RS_WEBAPP,
    entryDate: null,
    memo: null,
    entityID: NaN,
    amount: 0,
    receiptItems: null,
    paymentItems: null,
    check: null,

    /***************************************************************************
     * toJSON */
    /**
     * Since all the properties on the prototype may not be serialized, we want
     * the object to contain a direct representation of the properties when it is
     * converted to JSON for the server.
     ***************************************************************************/
    toJSON: function () {
      var result = {};
      for (var key in this) result[key] = this[key];

      return result;
    }
  };
}
